module.exports = __webpack_public_path__ + "img/3.e9d88fa6.svg";